__turbopack_context__.v({
  "benefitSection__openBtn": "PaymentCard-module-scss-module__dqCaUq__benefitSection__openBtn",
  "flatBenefit": "PaymentCard-module-scss-module__dqCaUq__flatBenefit",
  "flatBenefit__amountWrapper": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__amountWrapper",
  "flatBenefit__bestPrice": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__bestPrice",
  "flatBenefit__bestPriceAmount": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__bestPriceAmount",
  "flatBenefit__bestPriceText": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__bestPriceText",
  "flatBenefit__btn": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__btn",
  "flatBenefit__changeBtn": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__changeBtn",
  "flatBenefit__checkbox": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__checkbox",
  "flatBenefit__checkbox_selected": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__checkbox_selected",
  "flatBenefit__description": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__description",
  "flatBenefit__lowPayment": "PaymentCard-module-scss-module__dqCaUq__flatBenefit__lowPayment",
  "flatBenefit_selected": "PaymentCard-module-scss-module__dqCaUq__flatBenefit_selected",
});
